///////////////  LOGIN/SIGNOUT USER  \\\\\\\\\\\\\\\\\\\\\
export const loginWithFacebook = _ => ({ type: "LOGIN_WITH_FACEBOOK_REQUEST" });
export const loginWithEmailAndPassword = credentials => ({
  type: "LOGIN_WITH_EMAIL_AND_PASSWORD_REQUEST",
  credentials,
});
export const signupWithEmailAndPassword = userData => ({ type: "SIGNUP_WITH_EMAIL_AND_PASSWORD_REQUEST", userData });
export const sendPasswordResetEmail = email => ({ type: "SEND_PASSWORD_RESET_EMAIL_REQUEST", email });
export const verifyPasswordResetCode = () => ({ type: "VERIFY_PASSWORD_RESET_CODE_REQUEST" });
export const setisVerificationCodeVerified = isVerifed => ({
  type: "SET_IS_VERIFICATION_CODE_VERIFIED",
  isVerifed,
});
export const applyVerifyEmailActionCode = () => ({ type: "APPLY_VERIFY_EMAIL_ACTION_CODE_REQUEST" });

export const changePassword = password => ({ type: "CHANGE_PASSWORD_REQUEST", password });

export const signout = _ => ({ type: "SIGNOUT_REQUEST" });

///////////////  SET/UNSET USER  \\\\\\\\\\\\\\\\\\\\\
//this one takes unprocessed user.
export const setRawUser = user => ({ type: "SET_RAW_USER", user });
export const setUser = profile => ({ type: "SET_USER", profile });
export const clearUser = _ => ({ type: "CLEAR_USER" });

export const firebaseAuthDone = bool => {
  return {
    type: "FIREBASE_AUTH_DONE",
  };
};

export const isCreatingProfile = bool => {
  return {
    type: "IS_CREATING_PROFILE",
    payload: bool,
  };
};

export const createProfile = (profileData, handleSubmitErrors) => ({
  type: "CREATE_PROFILE_REQUEST",
  profileData,
  handleSubmitErrors,
});

export const updateProfile = (profileData, handleSubmitErrors) => ({
  type: "UPDATE_PROFILE_REQUEST",
  profileData,
  handleSubmitErrors,
});

export const fetchingUserProfile = bool => {
  return {
    type: "FETCHING_USER_PROFILE",
    payload: bool,
  };
};

export const showOnBoardingDimmer = (options = {}) => {
  const { onboardingMessage, onboardingDisplayFields } = options;
  return {
    type: "SHOW_ONBOARDING_DIMMER",
    onboardingMessage,
    onboardingDisplayFields,
  };
};

export const hideOnBoardingDimmer = () => {
  return {
    type: "HIDE_ONBOARDING_DIMMER",
  };
};

export const showProfileUpdateDimmer = (options = {}) => {
  const { onboardingMessage, onboardingDisplayFields } = options;
  return {
    type: "SHOW_PROFILE_UPDATE_DIMMER",
    onboardingMessage,
    onboardingDisplayFields,
  };
};

export const hideProfileUpdateDimmer = () => {
  return {
    type: "HIDE_PROFILE_UPDATE_DIMMER",
  };
};

export const userProfileIsFetched = bool => {
  return {
    type: "IS_USER_PROFILE_FETCHED",
    payload: bool,
  };
};

export const fetchUserExtraProfileData = userId => ({
  type: "FETCH_USER_EXTRA_PROFILE_DATA_REQUEST",
  userId,
});

export const followUser = ({ userId, postId }) => ({
  type: "FOLLOW_USER_REQUEST",
  userId,
  postId,
});
export const unfollowUser = ({ userId, postId }) => ({
  type: "UNFOLLOW_USER_REQUEST",
  userId,
  postId,
});

export const followUserOptimistic = ({ userId, postId }) => ({ type: "FOLLOW_USER_OPTIMISTIC", userId, postId });
export const unfollowUserOptimistic = ({ userId, postId }) => ({ type: "UNFOLLOW_USER_OPTIMISTIC", userId, postId });

export const followUserFailed = ({ userId, postId }) => ({
  type: "FOLLOW_USER_FAILED",
  userId,
  postId,
  error: `user.follow.error ${JSON.stringify(userId)}`,
});
export const unfollowUserFailed = ({ userId, postId }) => ({
  type: "UNFOLLOW_USER_FAILED",
  userId,
  postId,
  error: `user.unfollow.error ${JSON.stringify(userId)}`,
});

export const incrementUserLikes = () => ({ type: "INCREMENT_USER_LIKES" });

export const sendVerificationEmail = (successMessage, hideVerificationEmailBanner = true) => ({
  type: "SEND_VERIFICATION_EMAIL_REQUEST",
  successMessage,
  hideVerificationEmailBanner,
});

export const hideEmailVerificationBanner = () => ({ type: "HIDE_EMAIL_VERIFICATION_BANNER" });

export const showCookiesBar = () => ({ type: "SHOW_COOKIES_BAR" });

export const hideCookiesBar = () => ({ type: "HIDE_COOKIES_BAR" });

export const setSSRUserFlag = value => ({
  type: "SET_SSR_USER_FLAG",
  value
})

export default {
  createProfile,
  fetchingUserProfile,
  showOnBoardingDimmer,
  hideOnBoardingDimmer,
  fetchUserExtraProfileData,
  followUser,
  unfollowUser,
  followUserOptimistic,
  unfollowUserOptimistic,
  followUserFailed,
  unfollowUserFailed,
  updateProfile,
  hideEmailVerificationBanner,
  showCookiesBar,
  hideCookiesBar,
  setSSRUserFlag,
};



// WEBPACK FOOTER //
// ./src/actions/userActions.js